// import { Button, DialogTitle } from '@material-ui/core'
import Button from '@mui/material/Button'

import { GridColDef, DataGrid } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import { State } from '../types/state'
import { useParams } from 'react-router'
import { CSVLink } from 'react-csv'
import {
  generateStudentSelectionsReportData,
  generateSubjectSelectionsReportData
} from '../reports/utils'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Role } from '../types/user'
import { useState } from 'react'
import AddCommentDialog from '../users/AddCommentDialog'

export const SpecificUserGroup = () => {
  const { groupId } = useParams()
  const { myStudentGroups, studentsSelections, subjects, role } = useSelector(
    (state: State) => state.user
  )
  const isMobileView = useIsMobileView()
  const [commentData, setCommentData] = useState({
    userId: null as number | null,
    isOpen: false,
    username: null as string | null
  })
  const isLargeView = useIsLargeView()

  const SubjectsList: React.FC<{ id: number }> = ({ id }) => {
    const studentSelection = studentsSelections.find(s => s.id === id)!
    const subjectNames = studentSelection.selectedSubjects.map(
      s =>
        `${subjects.find(sub => sub.id === s.subjectId)?.name} - ${
          s.isHighLevel ? 'HL' : 'SL'
        }`
    )

    return (
      <div>
        {subjectNames.map((sn, index) =>
          (index + 1) % 3 === 0 ? (
            <>
              {sn},
              <br />
            </>
          ) : (
            <>{sn}, </>
          )
        )}
      </div>
    )
  }

  const AddCommentButton: React.FC<{ id: number }> = ({ id }) => {
    const userSelection = studentsSelections.find(s => s.id === id)!

    return role === Role.PARENT ? (
      <></>
    ) : (
      <Button
        variant='contained'
        style={{ fontSize: 11 }}
        onClick={() =>
          setCommentData({
            isOpen: true,
            userId: userSelection.id,
            username: userSelection.username
          })
        }
      >
        Add Comment
      </Button>
    )
  }

  const columns: GridColDef[] = [
    { field: 'username', headerName: 'Username', width: 120 },
    { field: 'firstName', headerName: 'First Name', width: 120 },
    { field: 'lastName', headerName: 'Last Name', width: 120 },
    {
      field: 'subjects',
      headerName: 'Subjects',
      width: 400,
      renderCell: params => <SubjectsList id={params.row.id} />
    },
    {
      field: 'commentButton',
      headerName: '',
      width: 120,
      renderCell: params => <AddCommentButton id={params.row.id} />
    }
  ]

  const currentGroup = myStudentGroups.find(g => g.id === Number(groupId))!

  const getSpecificUserGroup = () => {
    const currentGroupStudents = currentGroup.students.map(student =>
      studentsSelections.find(s => s.id === (student as any).userId)
    )
    return currentGroupStudents
  }

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      {commentData.isOpen && (
        <AddCommentDialog
          userId={commentData.userId!}
          username={commentData.username!}
          handleClose={() =>
            setCommentData({
              userId: null,
              username: null,
              isOpen: false
            })
          }
        />
      )}
      {(role === Role.ADMIN ||
        role === Role.SUPERADMIN ||
        role === Role.TEACHER) && (
        <>
          <CSVLink
            data={generateStudentSelectionsReportData(
              getSpecificUserGroup() as any,
              subjects
            )}
            filename='students-report.csv'
            separator=';'
          >
            <Button
              variant='outlined'
              style={{
                margin: '1vw',
                // marginLeft: isMobileView ? '20vw' : '40vw',
                fontSize: isMobileView ? '12px' : undefined,
                width: isMobileView ? '25vw' : '15vw'
              }}
              endIcon={<FileDownloadIcon />}
              onClick={async () => {}}
            >
              Students Report
            </Button>
          </CSVLink>
          <CSVLink
            data={generateSubjectSelectionsReportData(
              getSpecificUserGroup() as any,
              subjects,
              false
            )}
            filename='students-report.csv'
            separator=';'
          >
            <Button
              variant='outlined'
              style={{
                margin: '1vw',
                // marginLeft: isMobileView ? '20vw' : '40vw',
                fontSize: isMobileView ? '12px' : undefined,
                width: isMobileView ? '25vw' : '15vw'
              }}
              endIcon={<FileDownloadIcon />}
              onClick={async () => {}}
            >
              Subjects Report
            </Button>
          </CSVLink>
        </>
      )}
      {/* <DialogTitle>{currentGroup.name}</DialogTitle> */}
      <DataGrid
        disableRowSelectionOnClick
        rows={getSpecificUserGroup()}
        columns={columns}
        checkboxSelection={false}
      />
    </div>
  )
}

export default SpecificUserGroup
